import React from 'react';
import EmptyPrompt from './EmptyPrompt';
import { Text, Container } from '@mantine/core';
import { theme } from '../consilitheme';
import Logo from '../assets/img/triggers_empty_state.svg';

const TriggersManager = () => {
  const handleSynthesisClick = () => {};

  return (
    <Container>
      <Text
        fw={700}
        className="panel-title"
        mb={theme.padding.sm}
        pt={theme.padding.md}
      >
        Information Triggers
      </Text>{' '}
      <EmptyPrompt
        svgLink={Logo}
        description="Consili will update you when triggers become available"
        onClick={handleSynthesisClick}
      />
    </Container>
  );
};

export default TriggersManager;
